"use client";

import DateTime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import moment from "moment";

interface FromTimepickerProps {
  start_time: Date;
  end_time: Date;
  setValue: any;
}
export const FromTimepicker = ({
  start_time,
  end_time,
  setValue,
}: FromTimepickerProps) => {
  const onChange = (column: string, date: any) => {
    const value = moment(date).format("HH:mm:ss");
    setValue(column, value);
  };

  return (
    <div className="row">
      <div className="col-md-6">
        <div className="mb-3">
          <label className="form-label">시작일자 *</label>
          <DateTime
            dateFormat={false}
            timeFormat={"HH:mm:ss"}
            inputProps={{ placeholder: "Min Date" }}
            // closeOnSelect={true}
            value={start_time}
            onChange={(date) => onChange("start_time", date)}
          />
        </div>
      </div>
      <div className="col-md-6">
        <div className="mb-3">
          <label className="form-label">종료일자 *</label>
          <DateTime
            dateFormat={false}
            timeFormat={"HH:mm:ss"}
            inputProps={{ placeholder: "Max Date" }}
            // closeOnSelect={true}
            value={end_time}
            onChange={(date) => onChange("end_time", date)}
          />
        </div>
      </div>
    </div>
  );
};
